const RAW_API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  import.meta.env.VITE_API_URL?.replace(/\/api\/?$/, "");

const NORMALIZED_BASE = RAW_API_BASE_URL
  ? RAW_API_BASE_URL.replace(/\/$/, "")
  : "";

export const resolveAvatarUrl = (avatarPath) => {
  if (!avatarPath) {
    return undefined;
  }

  if (/^https?:\/\//i.test(avatarPath)) {
    return avatarPath;
  }

  if (!NORMALIZED_BASE) {
    return avatarPath;
  }

  const normalizedPath = avatarPath.startsWith("/")
    ? avatarPath
    : `/${avatarPath}`;

  return `${NORMALIZED_BASE}${normalizedPath}`;
};
